import React from 'react'
import { useSelector } from 'hooks'
import { NavLink } from 'react-router-dom'
import Button from 'components/Button'
import StyledPagination from './StyledPagination'
import { toQueryString } from 'utils'

const createRange = (current, total, diameter) => {
  const radius = Math.floor(diameter / 2)
  const from = current <= radius ? 1 : current - radius
  const to = Math.min(total, Math.max(current + radius, diameter))
  const pages = []
  for (let i = from; i <= to; i++) {
    pages.push(i)
  }
  return pages
}

const NavButton = props => <Button color="highlight" fill="transparent" {...props} />

const Pagination = ({ totalPages, range = 5 }) => {
  const query = useSelector(s => s.router.location.query)
  const current = parseInt(query.page) || 1
  const goTo = page => toQueryString({ ...query, page })

  return (
    <StyledPagination>
      <NavButton label="prev" disabled={current === 1} to={goTo(current - 1)} />
      <div className="center">
        {current >= 4 && (
          <>
            <NavLink className="page first-page" to={goTo(1)}>
              1
            </NavLink>
            <span className="dots">...</span>
          </>
        )}
        {createRange(current, totalPages, range).map(i => (
          <NavLink className="page" activeClassName="page--active" isActive={() => i === current} key={i} to={goTo(i)}>
            {i}
          </NavLink>
        ))}
      </div>
      <NavButton label="next" disabled={current === totalPages} to={goTo(current + 1)} />
    </StyledPagination>
  )
}

export default Pagination
